import React from "react";
import { AddPaymentLink } from "../components/AddPaymentLink";
import useAllStores from "../hooks/useAllStores";
import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { LoaderAction } from "redux/actions";
import { UTILS } from "utils";
import { API } from "api";
import { errorHandler } from "api/api/errorHandler";

const CreatePaymentLinks = () => {
  const { stores, loading } = useAllStores();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { control, handleSubmit, formState, setValue, trigger, watch } =
    useForm({
      defaultValues: {
        amount: "",
        paymentGateway: "",
        storeSelection: "",
        purposeOfPayment: "",
        message: "",
      },
      mode: "onChange",
    });

  const onFormSubmit = async (data) => {
    const purposeOfPayment = (data.purposeOfPayment || "").trim();
    const message = (data.message || "").trim();
    const amountNum = Number(String(data.amount).replace(/,/g, ""));

    const selectedStore = stores?.find(
      (s) => String(s.value) === String(data.storeSelection)
    );
    if (!selectedStore) {
      UTILS.errorNotification(t("Store is a required field"));
      return;
    }

    dispatch(LoaderAction.setLoading(true));
    try {
      const obj = {
        storeId: selectedStore.value,
        storeName: selectedStore.label,
        amount: Number(amountNum.toFixed(2)),
        currency: "AED",
        purposeOfPayment,
        message,
        paymentGateway: data?.paymentGateway || "STRIPE",
      };

      const userDetail = UTILS.getCurrentUser();
      const result = await API.CREATE_PAYMENT_LINK({
        brandId: userDetail.brandId,
        token: userDetail.token,
        data: obj,
      });

      if (result?.success === 1 && result?.data) {
        UTILS.handleSuccesNotification(
          result?.message ?? t("Payment link created successfully")
        );
        history.push("/app/dashboard/payment-link-detail", {
          paymentLink: result.data,
        });
      } else {
        UTILS.errorNotification(
          errorHandler(result?.message ?? result?.error?.message)
        );
      }
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.message || error?.error));
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };

  return (
    <div>
      <Spin spinning={loading || isLoading}>
        <AddPaymentLink
          onSubmit={handleSubmit(onFormSubmit)}
          stores={stores}
          control={control}
          errors={formState.errors}
          setValue={setValue}
          trigger={trigger}
          watch={watch}
        />
      </Spin>
    </div>
  );
};

export default CreatePaymentLinks;
